import { createTheme } from "@mui/material/styles";

// Define light theme
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#1976d2" },
    // background: { default: "#f7fafc", paper: "#f3f3f3" },
    background: { default: "#f3f3f3", paper: "#f3f3f3" },
    text: { primary: "#2d3748", secondary: "#718096" },
  },
});

// Define dark theme
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#90caf9" },
    background: { default: "#121212", paper: "#1d1d1d" },
    text: { primary: "#ffffff" },
  },
});
